import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";




export default function SettingsComponent() {
 

  return (
    <Grid container spacing={2}>
     <h2>Settings Component</h2>
    </Grid>
  );
}
